export const AUTH_CONFIG = {
  TOKEN_REFRESH_INTERVAL_MS: 14 * 60 * 1000,
  TOKEN_EXPIRATION_THRESHOLD_MS: 5 * 60 * 1000,
  USER_INACTIVITY_TIMEOUT_MS: 5 * 60 * 1000,
  TOKEN_CHECK_INTERVAL_MS: 60 * 1000,
  ACTIVITY_EVENTS: ['mousemove', 'keydown', 'scroll', 'pointerdown', 'click', 'touchstart'],
} as const;
